import React from "react";
import { motion } from "framer-motion";
import { Waves, Users, Sun, ShieldCheck } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Waves, Users, Sun, ShieldCheck];

export const BrandStory = () => {
  const { content } = useContent();
  const { L } = useLang();
  const a = content?.about || {};

  return (
    <section id="about" className="bg-sand-100 py-20 sm:py-28" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img src={a.image} alt="La community di Salty Folks sulla costa di Isola delle Femmine" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-ocean-900 text-sand-100 rounded-xl px-6 py-5 shadow-xl max-w-[220px]">
              <div className="font-mono text-[0.6rem] tracking-[0.2em] text-gold mb-1">EST. SICILY</div>
              <div className="font-heading text-lg font-bold leading-tight">Isola delle Femmine</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <p className="eyebrow text-coral mb-4">{L(a.eyebrow)}</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-ocean leading-[1.05] mb-6">
              {L(a.heading)}
            </h2>
            {(a.paragraphs || []).map((p, i) => (
              <p key={i} className="text-ocean/70 text-base sm:text-lg leading-relaxed mb-4">{L(p)}</p>
            ))}

            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              {(a.values || []).map((v, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div key={i} data-testid={`about-value-${i}`} className="flex gap-3 p-4 rounded-xl bg-white border border-ocean/10">
                    <div className="shrink-0 w-10 h-10 rounded-lg bg-ocean text-sand-100 flex items-center justify-center">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="font-heading font-bold text-ocean">{L(v.title)}</div>
                      <div className="text-sm text-ocean/60">{L(v.desc)}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
